import { Button, DialogActions, DialogContent, useTheme } from "@mui/material";
import { StyledAttachPdfDialog } from "../../styled/Dialogs";
import DropZone from "../dropZone/DropZone";
import HeaderForm from "../labels/HeaderForm";
import RequeridoLabel from "../labels/RequeridoLabel";
import CircularLoading from "../loading/CircularLoading";

const AttachPdfDialog = ({
  open,
  onClose,
  title,
  text,
  file,
  setFile,
  isAttaching,
  handleCancelClick,
  handleConfirmClick,
  isConfirmButtonDisabled,
  dropZoneText,
}) => {
  const theme = useTheme();

  return (
    <StyledAttachPdfDialog.AdjuntarFormularioDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <HeaderForm title={title ? title : "ADJUNTAR FORMULARIO"} />
      {isAttaching ? (
        <StyledAttachPdfDialog.LoadingContainer>
          <CircularLoading style={{ color: `${theme.palette.tertiary.main}` }} />
          <RequeridoLabel text="Adjuntando el formulario..." />
        </StyledAttachPdfDialog.LoadingContainer>
      ) : (
        <DialogContent>
          {text ? <StyledAttachPdfDialog.DialogText>{text}</StyledAttachPdfDialog.DialogText> : <></>}
          <DropZone
            file={file}
            setFile={setFile}
            loading={false}
            maxFiles={1}
            extension=".pdf"
            accept={{ "application/pdf": [".pdf"], }}
            dropZoneText="Arrastre el archivo .pdf aquí o haga click en el recuadro para adjuntarlo."
            dropZoneEditText="Si desea cambiar el archivo arrastrelo nuevamente o haga click en el recuadro."
          />
          <DialogActions>
            <Button color="primary" type="button" onClick={handleCancelClick}>
              Cancelar
            </Button>
            <Button
              disabled={isConfirmButtonDisabled}
              color="primary"
              variant="contained"
              onClick={handleConfirmClick}
            >
              Confirmar
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </StyledAttachPdfDialog.AdjuntarFormularioDialog>
  );
};

export default AttachPdfDialog;
